'use client';

import React from 'react';
import { Building2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useMondayAuth } from '@/contexts/MondayAuthContext';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export interface WorkspaceSelectorProps {
  collapsed?: boolean;
}

export function WorkspaceSelector({ collapsed = false }: WorkspaceSelectorProps) {
  const { account } = useMondayAuth();
  const workspaceName = account?.name || 'Workspace';

  const content = (
    <div
      className={cn(
        'flex items-center gap-3 px-3 py-2 rounded-lg bg-[var(--surface-bg)] border border-[var(--border-default)]',
        collapsed && 'justify-center px-2'
      )}
    >
      {/* Workspace Icon */}
      <div className="flex-shrink-0 w-6 h-6 bg-[var(--surface-skeleton)] rounded flex items-center justify-center">
        <Building2 className="w-4 h-4 text-[var(--text-secondary)]" />
      </div>

      {/* Workspace Name */}
      {!collapsed && (
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-[var(--text-heading)] truncate">
            {workspaceName}
          </p>
        </div>
      )}
    </div>
  );

  // Wrap in tooltip when collapsed
  if (collapsed) {
    return (
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>{content}</TooltipTrigger>
          <TooltipContent side="right">
            <span>{workspaceName}</span>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return content;
}
